<template>
  <div
    class="relative mx-auto flex justify-center items-stretch announcement overflow-hidden"
    :style="{
      background: announcement.backgroundColor
    }"
  >
    <div
      :style="{
        ...(announcement.imageLeftUrl ? { backgroundImage: `url(${announcement.imageLeftUrl})` } : {}),
        backgroundSize: 'auto 100%'
      }"
      class="flex-grow min-h-full bg-no-repeat bg-right"
    />

    <div
      class="announcement-text relative z-10 flex justify-center items-center flex-col py-2 min-h-12 px-5 min-w-[250px] max-w-[255px] sm:min-w-[290px] sm:max-w-[440px] md:min-w-[324px] md:max-w-[448px] lg:min-w-[624px] lg:max-w-[684px] xl:min-w-[684px] xl:max-w-[960px] 2xl:min-w-[684px] 2xl:max-w-[1400px]"
      :style="{
        color: announcement.textColor
      }"
      v-html="announcement.text"
    />

    <div
      :style="{
        ...(announcement.imageRightUrl ? { backgroundImage: `url(${announcement.imageRightUrl})` } : {}),
        backgroundSize: 'auto 100%'
      }"
      class="flex-grow min-h-full bg-no-repeat bg-left"
    />
    <button
      v-if="announcement.canHide"
      class="h-8 w-8 rounded-lg flex justify-center items-center absolute right-2.5 sm:right-5 lg:right-8 xl:right-12 bg-black/20 hover:bg-black/30 active:bg-black/40 top-1/2 -translate-y-1/2"
      @click="$emit('close')"
    >
      <CloseIcon />
    </button>
  </div>
</template>

<script>
import CloseIcon from '~/assets/svg/ui/close.svg?component'
export default {
  components: {
    CloseIcon,
  },
  props: {
    announcement: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
}
</script>

<style lang="sass" scoped>
  .announcement
    :deep(.announcement-text)
      p
        @apply text-inherit text-center text-xs md:text-sm
      a
        @apply text-blue-500 underline
</style>
